import React, { useEffect } from 'react';
import Clarity from '@microsoft/clarity';

// Extend Window interface to include clarity
declare global {
  interface Window {
    clarity: any;
  }
}

interface ClarityProviderProps {
  children: React.ReactNode;
  projectId?: string;
}

export const ClarityProvider: React.FC<ClarityProviderProps> = ({ 
  children, 
  projectId = import.meta.env.VITE_CLARITY_PROJECT_ID || 't9lbu6nzw0'
}) => {
  useEffect(() => {
    // Only initialize Clarity if we have a project ID and we're not in development
    if (projectId && import.meta.env.PROD) {
      try {
        // Initialize Microsoft Clarity
        Clarity.init(projectId);
        
        console.log('Microsoft Clarity initialized successfully');
      } catch (error) {
        console.error('Failed to initialize Microsoft Clarity:', error);
      }
    } else if (import.meta.env.DEV) {
      console.log('Microsoft Clarity is disabled in development mode');
    } else {
      console.warn('Microsoft Clarity project ID not provided');
    }
  }, [projectId]);

  return <>{children}</>;
};
